module.exports = __webpack_public_path__ + "c2a2ad2bd6c2df6bd1f602725c7df4fb.png";